var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.showAddMetricModal },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "PlusIcon" },
                          }),
                          _vm._v(" New Metric "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger", size: "sm" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.metricslist,
                          fields: _vm.metrics_fields,
                        },
                        on: { filtered: _vm.onFiltered },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(date)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatDateDDMMMYYYY(data.item.date)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.showEditMetricModal(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.confirmDeleteMetric(
                                              data.item.id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-1" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mb-1",
                                },
                                [
                                  _c("b-spinner", {
                                    staticStyle: {
                                      width: "3rem",
                                      height: "3rem",
                                    },
                                    attrs: {
                                      variant: "success",
                                      label: "Spinning",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalAddMetric",
                  attrs: {
                    id: "modal-add-metric",
                    title: "Add New Metric",
                    "hide-footer": "",
                    centered: "",
                  },
                  on: { hide: _vm.resetForm },
                },
                [
                  _c("validation-observer", {
                    ref: "addMetricForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(function (success) {
                                      return success && _vm.addNewMetric()
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Name*",
                                      "label-for": "name",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Name",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "name" },
                                                  model: {
                                                    value: _vm.newMetric.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newMetric,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newMetric.name",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Description*",
                                      "label-for": "description",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Description",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "description" },
                                                  model: {
                                                    value:
                                                      _vm.newMetric.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newMetric,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newMetric.description",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Target*",
                                      "label-for": "target",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Target",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "target",
                                                    type: "number",
                                                    min: "1",
                                                  },
                                                  model: {
                                                    value: _vm.newMetric.target,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newMetric,
                                                        "target",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newMetric.target",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Actual*",
                                      "label-for": "actual",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Actual",
                                        rules: "required|numeric",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "actual",
                                                    type: "number",
                                                    min: "1",
                                                  },
                                                  model: {
                                                    value: _vm.newMetric.actual,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newMetric,
                                                        "actual",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newMetric.actual",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Status*",
                                      "label-for": "status",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Status",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "status",
                                                    options: _vm.statusOptions,
                                                  },
                                                  model: {
                                                    value: _vm.newMetric.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newMetric,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newMetric.status",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Date",
                                      "label-for": "date",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "date",
                                        vid: "date",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "date",
                                                    placeholder: "Date",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    max: _vm.today,
                                                  },
                                                  model: {
                                                    value: _vm.newMetric.date,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newMetric,
                                                        "date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newMetric.date",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      disabled: invalid,
                                    },
                                  },
                                  [_vm._v(" Add Metric ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  ref: "modalEditMetric",
                  attrs: {
                    id: "modal-edit-metric",
                    title: "Edit Metric",
                    "hide-footer": "",
                    centered: "",
                  },
                },
                [
                  _c("validation-observer", {
                    ref: "editMetricForm",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var invalid = ref.invalid
                          var validate = ref.validate
                          return [
                            _c(
                              "b-form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    validate().then(function (success) {
                                      return success && _vm.updateMetric()
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Name",
                                      "label-for": "editName",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Name",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: { id: "editName" },
                                                  model: {
                                                    value: _vm.editMetric.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editMetric,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editMetric.name",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Description",
                                      "label-for": "editDescription",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Description",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-textarea", {
                                                  attrs: { id: "description" },
                                                  model: {
                                                    value:
                                                      _vm.editMetric
                                                        .description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editMetric,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editMetric.description",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Target",
                                      "label-for": "editTarget",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Target",
                                        rules: "required|numeric",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "target",
                                                    type: "number",
                                                    min: "1",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editMetric.target,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editMetric,
                                                        "target",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editMetric.target",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Actual",
                                      "label-for": "editActual",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Actual",
                                        rules: "required|numeric",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "Actual",
                                                    type: "number",
                                                    min: "1",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editMetric.actual,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editMetric,
                                                        "actual",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editMetric.actual",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Status",
                                      "label-for": "editStatus",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Status",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    id: "editStatus",
                                                    options: _vm.statusOptions,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editMetric.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editMetric,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editMetric.status",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Date",
                                      "label-for": "date",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "date",
                                        vid: "date",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "date",
                                                    placeholder: "Date",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    max: _vm.today,
                                                  },
                                                  model: {
                                                    value: _vm.editMetric.date,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editMetric,
                                                        "date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editMetric.date",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "submit",
                                      variant: "primary",
                                      disabled: invalid,
                                    },
                                  },
                                  [_vm._v(" Save Changes ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }